import React from 'react';
import moment from 'moment';

import { Grid, Typography } from '@material-ui/core';
import { Row } from '../../Resources';
import ActivitiesRegistrationHeader from 'components/ActivitiesRegistrationDetails/ActivitiesRegistrationHeader';

export default function RemoveOS({ lastRegister, activityData }) {
  return(
    <Grid container>
      <Grid xs={12}>
        <ActivitiesRegistrationHeader
          activityData={activityData}
        />
      </Grid>
      <Grid xs={12}>
        <div style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
          <Row>
            <Typography color='primary'>
              <b>Período</b>
            </Typography>
            <Typography color='textSecondary'>
              {moment(lastRegister?.period?.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY')} - {moment(lastRegister?.period?.endDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}
            </Typography>
          </Row>
          <Row marginTop={10}>
            <Typography color='primary'>
              <b>OSs removidas</b>
            </Typography>
            <div>
              {lastRegister?.removedIds?.length == 0 && (
                <Typography color='textSecondary'>
                  --
                </Typography>
              )}
              {lastRegister?.removedIds?.length > 0 && lastRegister?.removedIds?.map(id => {
                return(
                  <Typography color='textSecondary'>
                    {id}
                  </Typography>
                );
              })}
            </div>
          </Row>
        </div>
      </Grid>
    </Grid>
  );
}